module.exports = __webpack_public_path__ + "img/close-circle-outline-green.096043a7.svg";